import { type NextPage } from "next";

import { DocumentRenderer } from "~/components/ui/DocumentRenderer";

import { keystoneContext } from "@edwt/frontend/lib/keystone";
import type {
  WaitTimeReport,
  WaitTime,
  AboutPage as AboutPageType,
} from ".prisma/client";
import Layout from "~/components/layout/DefaultLayout";
import { env } from "~/env";

interface WaitTimeReportWithWaitTimes extends WaitTimeReport {
  waitTimes: WaitTime[];
}

/**
 * https://nextjs.org/docs/pages/building-your-application/data-fetching/get-static-props
 */
export async function getStaticProps() {
  if (process.env.BUILDING)
    return {
      notFound: true,
    };

  console.log("⚙️ Generating static page for About route ('/about')");

  const About = await keystoneContext.prisma.aboutPage.findFirst();

  return {
    props: {
      About: About,
    },
    revalidate: env.REVALIDATE_PAGE_TIME_MINUTES * 60,
  };
}

/**
 * Simple About page that renders rich text field from CMS
 */
const AboutPage: NextPage<{
  About: AboutPageType | null;
}> = ({ About }) => {
  const typedAboutDocument = About
    ? (About.document as any as Element[])
    : null;

  return (
    <Layout pageTitle="About">
      <h1 className="mb-10 text-2xl">{About?.title}</h1>
      <article className="prose">
        {About && About.document ? (
          /* @ts-ignore */
          <DocumentRenderer document={typedAboutDocument} />
        ) : (
          false
        )}
      </article>
    </Layout>
  );
};

export default AboutPage;
